module.exports = __webpack_public_path__ + "img/22_67.1922a4eb.png";